(() => {
  'use strict';

  // Cargador compartido de Google Maps (callback, API clásica). Pide places+marker
  // para que el mapa y las reseñas funcionen aunque solo una sección dispare la carga.
  const ensureGmaps = (apiKey) => {
    if (window.google?.maps?.Map) return;
    if (window.__wimGmaps) return;
    window.__wimGmaps = { loaded: false };
    // El nombre __wimGmapsReady es el callback= de la URL de Google Maps: no renombrar.
    window.__wimGmapsReady = () => {
      window.__wimGmaps.loaded = true;
      document.dispatchEvent(new Event('wim:gmaps'));
    };
    const s = document.createElement('script');
    s.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}` +
      '&libraries=places,marker&loading=async&callback=__wimGmapsReady';
    s.async = true;
    s.onerror = () => console.warn('[wim-map] no se pudo cargar Google Maps');
    document.head.appendChild(s);
  };

  const createMap = (el) => {
    const lat = Number.parseFloat(el.dataset.lat);
    const lng = Number.parseFloat(el.dataset.lng);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return;
    const center = { lat, lng };

    const options = {
      center,
      zoom: Number.parseInt(el.dataset.zoom ?? '14', 10),
      mapTypeId: el.dataset.mapType || 'roadmap',
    };
    if (el.dataset.style) {
      try { options.styles = JSON.parse(el.dataset.style); } catch {}
    }

    const map = new google.maps.Map(el, options);
    const markerOpts = { position: center, map, title: el.dataset.title || '' };
    if (el.dataset.marker) {
      markerOpts.icon = { url: el.dataset.marker, scaledSize: new google.maps.Size(48, 48) };
    }
    new google.maps.Marker(markerOpts);
  };

  const runMaps = () => {
    for (const el of document.querySelectorAll('[data-wim-map]')) {
      if (el.__wimMapInit) continue;
      el.__wimMapInit = true;
      try { createMap(el); } catch (e) { console.warn('[wim-map]', e); }
    }
  };

  const init = () => {
    const first = document.querySelector('[data-wim-map]');
    if (!first) return;
    if (window.google?.maps?.Map) { runMaps(); return; }
    ensureGmaps(first.dataset.apiKey);
    document.addEventListener('wim:gmaps', runMaps);
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
